function CardSlider(obj) {
  this.sliderObject = obj;
  this.auto = true;
  this.timeouts = [];
  this.isJumping = false;
}

CardSlider.prototype.slide = function () {
  this.parent = document.querySelector(this.sliderObject.parent);

  // Save original slides
  const originals = Array.from(this.parent.children);

  // Clone slides
  const firstClone = originals[0].cloneNode(true);
  const lastClone = originals[originals.length - 1].cloneNode(true);
  firstClone.classList.add("clone");
  lastClone.classList.add("clone");

  this.parent.appendChild(firstClone);
  this.parent.insertBefore(lastClone, originals[0]);

  this.sliderBlocks = Array.from(this.parent.children);

  // Wrapper
  this.wrapper = document.createElement("div");
  this.wrapper.classList.add("custom-slide-init");
  this.parent.classList.add("custom-slide-wrapper");
  this.parent.parentNode.insertBefore(this.wrapper, this.parent);
  this.wrapper.appendChild(this.parent);

  this.sliderBlocks.forEach(el => el.classList.add("custom-slider-block"));

  this.responsiveArray = this.sliderObject.responsive;

  this.startSlider();
  this.startDots();
  this.arrows();
  this.autoplay();
  this.sliderTouch();

  // Start on first REAL slide
  requestAnimationFrame(() => {
    this.parent.scrollLeft = this.sliderBlocks[0].clientWidth;
  });

  this.parent.addEventListener("scroll", () => this.handleInfinite());

  window.addEventListener("resize", () => {
    this.startSlider();
    this.startDots();
  });
};

CardSlider.prototype.startSlider = function () {
  const parent = this.parent;

  this.responsiveArray.forEach(el => {
    if (
      window.matchMedia(
        `(min-width:${el.breakpoint[0]}px) and (max-width:${
          el.breakpoint[1] === "auto" ? "5000" : el.breakpoint[1]
        }px)`
      ).matches
    ) {
      parent.style.gap = `${el.gap || 0}px`;

      this.sliderBlocks.forEach(block => {
        block.style.flex = `0 0 ${100 / el.slidesToShow}%`;
        block.style.maxWidth = `${100 / el.slidesToShow}%`;
      });
    }
  });
};

CardSlider.prototype.handleInfinite = function () {
  if (this.isJumping) return;

  const slideWidth = this.sliderBlocks[0].clientWidth;
  const total = this.sliderBlocks.length;

  // Disable smooth scroll temporarily
  if (this.parent.scrollLeft <= 0) {
    this.jumpWithoutAnimation(slideWidth * (total - 2));
  }

  if (this.parent.scrollLeft >= slideWidth * (total - 1)) {
    this.jumpWithoutAnimation(slideWidth);
  }
};

CardSlider.prototype.jumpWithoutAnimation = function (position) {
  this.isJumping = true;

  // 🔑 CRITICAL FIX
  this.parent.style.scrollBehavior = "auto";
  this.parent.scrollLeft = position;

  // Restore smooth scrolling
  requestAnimationFrame(() => {
    this.parent.style.scrollBehavior = "smooth";
    this.isJumping = false;
  });
};

CardSlider.prototype.startDots = function () {
  const wrapper = this.wrapper;
  const parent = this.parent;

  wrapper.querySelector(".custom-dots-wrapper")?.remove();
  wrapper.insertAdjacentHTML("beforeend", `<div class="custom-dots-wrapper"></div>`);

  const dotsWrapper = wrapper.querySelector(".custom-dots-wrapper");
  const realSlides = this.sliderBlocks.length - 2;
  const slideWidth = this.sliderBlocks[0].clientWidth;

  for (let i = 0; i < realSlides; i++) {
    dotsWrapper.insertAdjacentHTML("beforeend", `<div class="custom-dot"></div>`);
  }

  const updateDots = () => {
    let index = Math.round(parent.scrollLeft / slideWidth) - 1;
    if (index < 0) index = realSlides - 1;
    if (index >= realSlides) index = 0;

    dotsWrapper.querySelectorAll(".custom-dot").forEach((d, i) =>
      d.classList.toggle("active", i === index)
    );
  };

  updateDots();
  parent.addEventListener("scroll", updateDots);

  dotsWrapper.querySelectorAll(".custom-dot").forEach((dot, i) => {
    dot.onclick = () => {
      this.stopAutoplay();
      parent.scrollLeft = slideWidth * (i + 1);
    };
  });
};

CardSlider.prototype.arrows = function () {
  const wrapper = this.wrapper;
  const parent = this.parent;
  const slideWidth = this.sliderBlocks[0].clientWidth;

  wrapper.querySelector(".custom-arrows")?.remove();
  wrapper.insertAdjacentHTML(
    "beforeend",
    `<div class="custom-arrows">
      <button class="custom-arrow-prev">◀</button>
      <button class="custom-arrow-next">▶</button>
    </div>`
  );

  wrapper.querySelector(".custom-arrow-next").onclick = () => {
    this.stopAutoplay();
    parent.scrollLeft += slideWidth;
  };

  wrapper.querySelector(".custom-arrow-prev").onclick = () => {
    this.stopAutoplay();
    parent.scrollLeft -= slideWidth;
  };
};

CardSlider.prototype.autoplay = function () {
  const parent = this.parent;
  const slideWidth = this.sliderBlocks[0].clientWidth;

  this.responsiveArray.forEach(el => {
    if (!el.autoplay) return;

    setInterval(() => {
      if (!this.auto) return;
      parent.scrollLeft += slideWidth;
    }, el.time);
  });
};

CardSlider.prototype.stopAutoplay = function () {
  this.auto = false;
  this.timeouts.forEach(clearTimeout);
  this.timeouts = [];

  this.timeouts.push(
    setTimeout(() => (this.auto = true), 5000)
  );
};

CardSlider.prototype.sliderTouch = function () {
  this.parent.addEventListener("touchstart", () => this.stopAutoplay());
};
